import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { EmotionClassStyles } from "@/domains/emotion/types";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";

type EditorSpinnerProps = EmotionClassStyles & {
  minHeight?: number;
  isOverlay?: boolean;
  show?: boolean;
  hideDelay?: number;
};

export const EditorSpinner: React.FC<EditorSpinnerProps> = ({
  className,
  minHeight = 200,
  isOverlay = false,
  show = true,
  hideDelay = 300,
}) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
    } else if (hideDelay > 0) {
      const timeout = setTimeout(() => {
        setIsVisible(false);
      }, hideDelay);
      return () => clearTimeout(timeout);
    } else {
      setIsVisible(false);
    }
  }, [show, hideDelay]);

  if (!isVisible) {
    return null;
  }

  return (
    <StyledContainer
      className={className}
      minHeight={minHeight}
      isOverlay={isOverlay}
      data-component="EditorSpinner"
    >
      <LargeSpinner kind={MdsIconKind.Spinner} />
    </StyledContainer>
  );
};

type StyledContainerProps = {
  minHeight: number;
  isOverlay: boolean;
};

const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ isOverlay, minHeight }) => (isOverlay ? "auto" : `${minHeight}px`)};
  width: 100%;

  ${({ isOverlay, theme }) =>
    isOverlay &&
    `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${theme.colors.surface.pane};
    opacity: 1;
    z-index: 1000;
  `}
`;

const LargeSpinner = styled(MdsIcon)`
  svg {
    width: 32px;
    height: 32px;
  }
`;
